import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * RadioCard do DS (ORCA-1929). Coloque vários dentro de um elemento com role="radiogroup".
 * O conteúdo projetado (ex.: oa-installment-picker) só aparece com o card selecionado.
 */
@Component({
    selector: 'oa-radio-card',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <div class="oa-rcard" [class.oa-rcard--on]="selected">
            <button type="button" class="oa-rcard__head" role="radio" [attr.aria-checked]="selected ? 'true' : 'false'"
                [disabled]="disabled" (click)="select.emit()">
                <span class="oa-rcard__dot" aria-hidden="true"></span>
                <mat-icon *ngIf="icon" class="oa-rcard__icon" aria-hidden="true">{{ icon }}</mat-icon>
                <span *ngIf="!icon"></span>
                <span class="oa-rcard__text">
                    <b>{{ title }}</b>
                    <span *ngIf="description">{{ description }}</span>
                </span>
                <span class="oa-rcard__end" *ngIf="value || badge">
                    <b *ngIf="value">{{ value }}</b>
                    <span *ngIf="badge" class="oa-rcard__badge">{{ badge }}</span>
                </span>
            </button>
            <div class="oa-rcard__body" *ngIf="selected"><ng-content></ng-content></div>
        </div>
    `,
    styles: [':host { display: block; } .oa-rcard__body:empty { display: none; }'],
})
export class OaRadioCardComponent {
    @Input() title = '';
    @Input() description?: string;
    @Input() icon?: string;
    @Input() value?: string;
    @Input() badge?: string;
    @Input() selected = false;
    @Input() disabled = false;
    @Output() select = new EventEmitter<void>();
}
